export class CasesFilter {
  fromDate: Date;
  toDate: Date;
  filteringText: string;
  customerProfileId: string;
  caseTypeCode: string | null;

  public constructor(init?: Partial<CasesFilter>) {
    Object.assign(this, init);
  }
}
